module.exports = __webpack_public_path__ + "static/media/fazanlogofull.e6b4da48.png";